import React from 'react';
import styled from '@emotion/styled';
import { font, remCalc } from '../../css';
import Switch, { defaultProps, propTypes } from './Switch';

const AutoplayContainer = styled('div')({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    fontFamily: font.family.body,
    fontSize: font.size.xs,
    lineHeight: font.lineHeight.m,
});

const SwitchWithLabel = ({ className, id, isChecked, onChange, label }) => (
    <AutoplayContainer className={className}>
        <Switch id={id} label={label} isChecked={isChecked} onChange={onChange} />
    </AutoplayContainer>
);

SwitchWithLabel.propTypes = propTypes;

SwitchWithLabel.defaultProps = defaultProps;

export default SwitchWithLabel;
